import { defineStore } from "pinia";

export const useCartStore = defineStore("cart", {
	state: () => {
		return {
			cartCount: 0,
			cartItems: {},
			cartItemsValid: true,
			cartTotals: {},
			cartDeliveryDate: "",
		};
	},
	actions: {
		setCartCount(cartCount) {
			this.cartCount = cartCount;
		},
		setCartItems(items) {
			this.cartItems = items;
			if (!items) {
				this.cartCount = 0;
			} else {
				this.cartCount = Object.keys(items).length;
				this.cartItemsValid = true;
				Object.keys(items).forEach((key) => {
					const item = items[key];
					if (item.item.has_error) {
						this.cartItemsValid = false;
					}
				});
			}
		},
		setCartTotals(totals) {
			this.cartTotals = totals;
		},
		setDeliveryDate(deliveryDate) {
			this.cartDeliveryDate = deliveryDate;
		},
	},
});
